function leafLen(n: Node): number {
  return n.nodeType === Node.TEXT_NODE ? (n as Text).length : (n as Element).childNodes.length;
}
function blockAncestor(node: Node, root: HTMLElement): HTMLElement | null {
  let n: Node | null = node;
  while (n && n !== root) {
    const p: Node | null = n.parentNode;
    if (p === root && n.nodeType === Node.ELEMENT_NODE) return n as HTMLElement;
    n = p;
  }
  return null;
}

export function analyzeEditorRange(
  root: HTMLElement | null,
  range: Range | null
): {
  atLeftEdge: boolean;
  atRightEdge: boolean;
  atFirstLine: boolean;
  atLastLine: boolean;
  allSelected: boolean;
} {
  if (!root || !range) {
    return {
      atLeftEdge: true,
      atRightEdge: true,
      atFirstLine: true,
      atLastLine: true,
      allSelected: false,
    };
  }

  const head = document.createRange();
  if (root.firstChild) head.setStartBefore(root.firstChild);
  else head.setStart(root, 0);
  head.setEnd(range.startContainer, range.startOffset);
  const atLeftEdge = head.toString().length === 0;

  const tail = document.createRange();
  tail.setStart(range.endContainer, range.endOffset);
  if (root.lastChild) tail.setEndAfter(root.lastChild);
  else tail.setEnd(root, leafLen(root));
  const atRightEdge = tail.toString().length === 0;

  const hasContent = (root.textContent ?? '').length > 0;
  const allSelected = atLeftEdge && atRightEdge && hasContent;

  const blocks = Array.from(root.children) as HTMLElement[];
  const startBlock = blockAncestor(range.startContainer, root);
  const endBlock = blockAncestor(range.endContainer, root);
  const atFirstLine = blocks.length === 0 || startBlock === blocks[0];
  const atLastLine = blocks.length === 0 || endBlock === blocks[blocks.length - 1];

  return { atLeftEdge, atRightEdge, atFirstLine, atLastLine, allSelected };
}
